export default {
    setSearchExpertResults (state, { results }) {
        console.log('------------------------Entered setSearchExpertResults------------------------')
        console.log('setSearchExpertResults', state, results)
        state.searchResults1 = results
        console.log(state)
    },
    setSearchResults (state, { results }) {
        console.log('-------------------Entered setSearchResults------------------------')
        console.log('setSearchReults', state, results)
        state.searchResults = results
        console.log(state)
    },
    setSearchPlaylistResults (state, { results }) {
        console.log('------------------------setSearchPlaylistResults------------------------', state, results)
        state.searchResults2 = results
        console.log(state)
    }
}



// WEBPACK FOOTER //
// ./src/store/search/mutations.js